import App from './App.svelte';

const app = new App({
	target: document.querySelector('#e_consent'),
	props: {
		configOverride: {},
	}
});

export default app;
